module.exports = __webpack_public_path__ + "favicon.svg";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=favicon.svg!./images/favicon.svg
// module id = 872
// module chunks = 1